const SUBMIT_SALESFORCE_TICKET = 'SUPPORT/SUBMIT_SALESFORCE_TICKET';

export { SUBMIT_SALESFORCE_TICKET };
